import { WidgetGlobalStyles, WidgetHeaderStyles } from '../types';
import { computeStyles } from './computeStyles';

export function computeHeaderStyles(
    style: WidgetHeaderStyles | undefined,
    parentStyle?: WidgetGlobalStyles | undefined,
    isStandalone?: boolean,
) {
    const main = computeStyles(style?.main) || {};
    const wrapper = computeStyles(style?.wrapper);
    const icon = computeStyles(style?.icon);
    const label = computeStyles(style?.label);

    const mainDisplay = main?.display || 'block';

    if (mainDisplay === 'block') {
        if (parentStyle?.borderTopRightRadius) {
            main.borderTopRightRadius = parentStyle.borderTopRightRadius;
        }
        if (parentStyle?.borderTopLeftRadius) {
            main.borderTopLeftRadius = parentStyle.borderTopLeftRadius;
        }
        if (isStandalone) {
            if (parentStyle?.borderBottomRightRadius) {
                main.borderBottomRightRadius = parentStyle.borderBottomRightRadius;
            }
            if (parentStyle?.borderBottomLeftRadius) {
                main.borderBottomLeftRadius = parentStyle.borderBottomLeftRadius;
            }
        }
    }

    return { main, wrapper, icon, label };
}
